import React from 'react';
import { useLocation } from 'react-router-dom';
import { MassMailProvider } from './context/MassMailContext';
import { MassMailContent } from './components/MassMailContent';
import { HelpdeskEmail, MassMailState } from './types';

// `replyToEmail` is consumed by MassMailContent (same prop the helpdesk modal
// uses) and isn't part of MassMailState — pull it out of location.state so we
// can forward it as a prop instead of seeding it into the reducer.
type MassMailLocationState = Partial<MassMailState> & {
  replyToEmail?: HelpdeskEmail;
};

const MassMailPage: React.FC = () => {
  const location = useLocation();

  // Read location.state directly (no intermediate state to avoid race condition)
  const locationState = location.state as MassMailLocationState | undefined;

  // Fallback: Check sessionStorage for context data
  let initialState: MassMailLocationState | undefined = locationState;

  if (!initialState) {
    const storedContext = sessionStorage.getItem('massmail-context');
    if (storedContext) {
      try {
        initialState = JSON.parse(storedContext);
        console.log('📧 Loading mass-mail context from sessionStorage:', initialState);
        // Clear sessionStorage after loading
        sessionStorage.removeItem('massmail-context');
      } catch (error) {
        console.error('❌ Error parsing mass-mail context:', error);
      }
    }
  } else {
    console.log('📧 Loading mass-mail context from location.state:', locationState);
  }

  const { replyToEmail, ...providerInitialState } = initialState || {};

  return (
    <MassMailProvider initialState={providerInitialState}>
      <div className="w-full min-h-screen flex flex-col bg-white">
        <MassMailContent replyToEmail={replyToEmail} />
      </div>
    </MassMailProvider>
  );
};

export default MassMailPage;
